<div [style.height]="fill() + 'px'"></div>
<div
  class="sticky"
  #stickyRef
  [ngStyle]="{
    top: scrollDirection() === 'down' ? positionOffset() - 24 + 'px' : 'auto',
    bottom: scrollDirection() === 'up' ? positionOffset() - 100 + 'px' : 'auto',
  }"
>
  <ng-content />
</div>
